import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { scrollToSection } from "../lib/scroll";

export const NAV_LINKS = [
  ["Startseite", "start"],
  ["Angebot", "angebot"],
  ["Preise", "preise"],
  ["Events", "anlaesse"],
  ["Über uns", "lounge"],
  ["Kontakt", "kontakt"],
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToSection(id), open ? 150 : 0);
  };

  return (
    <>
      <header
        data-testid="site-header"
        className={`fixed inset-x-0 top-0 z-[80] transition-colors duration-500 ${
          scrolled
            ? "border-b border-[#241a15] bg-[#120d0b]/90 backdrop-blur-xl"
            : "bg-gradient-to-b from-[#120d0b]/80 to-transparent"
        }`}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10">
          <button data-testid="logo-button" onClick={() => go("start")} className="flex items-center gap-3">
            <img
              src="/images/logo.png"
              alt="Vintage Billard Logo"
              className="h-11 w-11 rounded-full border border-[#c9a24a]/40 object-cover"
            />
            <span className="font-display text-lg tracking-wide text-[#f4ecdd]">Vintage Billard</span>
          </button>
          <nav className="hidden items-center gap-8 lg:flex">
            {NAV_LINKS.map(([label, id]) => (
              <button
                key={id}
                data-testid={`nav-${id}`}
                onClick={() => go(id)}
                className="text-[13px] uppercase tracking-[0.18em] text-[#c9bda9] transition-colors duration-300 hover:text-[#e3c988]"
              >
                {label}
              </button>
            ))}
            <button
              data-testid="nav-cta"
              onClick={() => go("preise")}
              className="border border-[#c9a24a] px-5 py-2 text-[13px] uppercase tracking-[0.18em] text-[#c9a24a] transition-colors duration-300 hover:bg-[#c9a24a] hover:text-[#120d0b]"
            >
              Tisch sichern
            </button>
          </nav>
          <button
            data-testid="mobile-menu-button"
            className="text-[#f4ecdd] lg:hidden"
            onClick={() => setOpen(true)}
            aria-label="Menü öffnen"
          >
            <Menu size={26} />
          </button>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            className="fixed inset-0 z-[90] flex flex-col bg-[#120d0b]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35 }}
          >
            <div className="flex items-center justify-between px-6 py-4">
              <span className="font-display text-lg text-[#f4ecdd]">Vintage Billard</span>
              <button data-testid="mobile-menu-close" onClick={() => setOpen(false)} aria-label="Menü schließen">
                <X size={26} className="text-[#f4ecdd]" />
              </button>
            </div>
            <nav className="flex flex-1 flex-col items-start justify-center gap-2 px-8">
              {NAV_LINKS.map(([label, id], i) => (
                <motion.button
                  key={id}
                  data-testid={`mobile-nav-${id}`}
                  initial={{ opacity: 0, y: 24 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.07 * i, duration: 0.5 }}
                  onClick={() => go(id)}
                  className="py-2 font-display text-4xl font-light text-[#f4ecdd] transition-colors hover:text-[#e3c988]"
                >
                  {label}
                </motion.button>
              ))}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
